module.exports = __webpack_public_path__ + "img/donut.b7182757.png";